import { get, put } from "./apiService";
import { ApiUrls } from "./ApiUrls";

export const getUserDetails = async () => {
  try {
    const res = await get(ApiUrls.users.me);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

// System Admin only. Real data — total active-user count, most recently
// onboarded users with the email already masked server-side, and a 6-month
// onboarding trend.
export const getUserOnboardingStats = async () => {
  try {
    const res = await get(ApiUrls.users.onboardingStats);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

type UserListParams = {
  roles: string[];
};

export const getUserList = async (params?: UserListParams) => {
  try {
    const res = await get(ApiUrls.users.users, {
      params,
      paramsSerializer: (params) => {
        const query = new URLSearchParams();
        params.roles.forEach((role: string) => query.append("roles", role));
        return query.toString();
      },
    });
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const reAssignCompanies = async (
  id: string,
  payload: { company_ids: string[] }
) => {
  try {
    const res = await put(ApiUrls.users.reAssignCompanies(id), payload);
    return res;
  } catch (error: any) {
    return error.response;
  }
};

export const changeUserRole = async (
  id: string,
  payload: { roles: string[] }
) => {
  try {
    const res = await put(ApiUrls.users.changeRole(id), payload);
    return res;
  } catch (error: any) {
    return error.response;
  }
};
